var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-to-clipboard"},[_vm._t("default",null,{"copy":_vm.copyToClipboard,"copied":_vm.copied,"canCopy":_vm.isClipboardAvailable})],2)}
var staticRenderFns = []

export { render, staticRenderFns }